// Page copy for the redesigned Studio. Keep enUS and zhCN structurally identical.
export const enUS = {
  title: 'Updates',
  intro: 'Account activity, announcements, and replies from Support — all in one place.',
  bell: {
    label: 'Updates',
    unreadLabel: 'Updates, {count} unread',
    unreadCount: '{count} unread',
    close: 'Close updates',
    loading: 'Loading updates…',
    loadFailed: 'Could not load updates',
    emptyTitle: 'No updates yet',
    emptyBody: 'Account updates and replies from Support will appear here',
    markAll: 'Mark all as read',
    viewAll: 'View all updates',
  },
  categories: {
    all: 'All updates',
    notification: 'Notifications',
    announcement: 'Announcements',
    support: 'Support',
  },
  item: {
    label: 'Notification',
    announcement: 'Announcement',
    support: 'Support · {subject}',
    read: 'Read',
    unread: 'Unread',
    markRead: 'Mark {title} as read',
    delete: 'Delete update: {title}',
  },
  support: {
    chatReply: 'New message from Spatius',
    ticketReply: 'Reply to your ticket',
  },
  filters: {
    category: 'Message category',
    status: 'Read status',
    all: 'All statuses',
    unread: 'Unread',
    refresh: 'Refresh updates',
  },
  actions: {
    markAll: 'Mark all as read',
    retry: 'Retry',
    loadMore: 'Load older updates',
    viewAll: 'View all updates',
  },
  footer: {
    count: '{shown} of {total} updates',
  },
  state: {
    loading: 'Loading updates…',
    loadFailed: 'Could not load updates',
    refreshFailed: 'Could not refresh updates. The list may be out of date.',
    markFailed: 'Could not mark this update as read. Try again.',
    markAllFailed: 'Could not mark all updates as read. Try again.',
    deleteFailed: 'Could not delete this update. Try again.',
  },
  empty: {
    all: { title: 'No updates yet', body: 'Account and Support updates will appear here' },
    unread: { title: 'All caught up', body: 'Other updates are still available in the full list' },
    unreadPrefix: 'unread ',
    notification: 'No {unread}notifications',
    announcement: 'No {unread}announcements',
    support: 'No {unread}Support updates',
  },
  announcement: {
    back: 'Back to updates',
    loading: 'Loading announcement…',
    loadFailed: 'Could not load announcement',
    unavailable: 'Announcement unavailable',
    unavailableHint: 'This announcement may have been removed. Your other updates are still available.',
    contactSupport: 'Contact Support about this',
    learnMore: 'Learn more',
  },
}

export const zhCN = {
  title: '消息',
  intro: '账户动态、公告和来自支持的回复，都在这里。',
  bell: {
    label: '消息',
    unreadLabel: '消息，{count} 条未读',
    unreadCount: '{count} 条未读',
    close: '关闭消息',
    loading: '正在加载消息…',
    loadFailed: '暂时无法加载消息',
    emptyTitle: '暂无消息',
    emptyBody: '账户动态和支持的回复会显示在这里',
    markAll: '全部标为已读',
    viewAll: '查看全部消息',
  },
  categories: {
    all: '全部消息',
    notification: '通知',
    announcement: '公告',
    support: '支持',
  },
  item: {
    label: '通知',
    announcement: '公告',
    support: '支持 · {subject}',
    read: '已读',
    unread: '未读',
    markRead: '将“{title}”标为已读',
    delete: '删除消息：{title}',
  },
  support: {
    chatReply: 'Spatius 发来新消息',
    ticketReply: '你的工单有新回复',
  },
  filters: {
    category: '消息类别',
    status: '阅读状态',
    all: '全部状态',
    unread: '未读',
    refresh: '刷新消息',
  },
  actions: {
    markAll: '全部标为已读',
    retry: '重试',
    loadMore: '加载更早的消息',
    viewAll: '查看全部消息',
  },
  footer: {
    count: '已显示 {shown} / {total} 条',
  },
  state: {
    loading: '正在加载消息…',
    loadFailed: '暂时无法加载消息',
    refreshFailed: '刷新失败，列表可能不是最新的。',
    markFailed: '标为已读失败，请重试。',
    markAllFailed: '全部标为已读失败，请重试。',
    deleteFailed: '删除失败，请重试。',
  },
  empty: {
    all: { title: '暂无消息', body: '账户动态和支持的回复会显示在这里' },
    unread: { title: '都已读完', body: '其他消息仍可在完整列表中查看' },
    unreadPrefix: '未读',
    notification: '暂无{unread}通知',
    announcement: '暂无{unread}公告',
    support: '暂无{unread}支持消息',
  },
  announcement: {
    back: '返回消息列表',
    loading: '正在加载公告…',
    loadFailed: '暂时无法加载公告',
    unavailable: '公告不可用',
    unavailableHint: '这条公告可能已被移除，你的其他消息仍然可用。',
    contactSupport: '就此联系支持',
    learnMore: '了解更多',
  },
}
